import React, { useState } from 'react'
import s from './BookingSuccess.module.scss'
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader'
import { ReactComponent as Unchecked } from 'images/new-icons/unchecked_primary_radio_button.svg'
import { ReactComponent as Checked } from 'images/new-icons/checked_primary_radio_button.svg'
import Button from 'components/shared/Button'

const options = [
    {
        id: 1,
        text: 'Weather Conditions'
    },
    {
        id: 2,
        text: 'Parking Availability'
    },
    {
        id: 3,
        text: 'Lack of amenities'
    },
    {
        id: 4,
        text: 'I have alternative option'
    },
    {
        id: 5,
        text: 'Other'
    },
]

const CancelAppointment = ({ setShowCancel, handleCancelBooking, canceledOption, setCanceledOption, setCancelNote, cancelNote }) => {

    return (
        <div className={s.cancel}>
            <ProfileMenuHeader text="Cancel appointment" onClose={() => setShowCancel(false)} />
            <div className={s.cancel_inner}>
                {options.map((item) => {
                    return (
                        <div key={item.id} className={s.cancel_inner_radio_buttons} onClick={() => setCanceledOption(item.text)}>
                            {canceledOption === item.text ? <Checked /> : <Unchecked />}
                            <div>{item.text}</div>
                        </div>
                    )
                })}
            </div>
            <div className={s.cancel_actions}>
                <div className={s.cancel_actions_title}>Other</div>
                <textarea
                    disabled={canceledOption !== 'Other'}
                    placeholder='Note'
                    style={{
                        opacity: canceledOption !== 'Other' ? 0.5 : 1
                    }}
                    onChange={(e) => setCancelNote(e.target.value)}
                />
                <Button
                    wide
                    darkGreen
                    onClick={handleCancelBooking}
                >Cancel appointment</Button>
            </div>
        </div>
    )
}

export default CancelAppointment